import React, {Component} from 'react';
import Paper from '@material-ui/core/Paper';
import PollForm from './PollForm';
import axios from '../../axios-admin';

class PollNew extends Component {

    constructor(props) {
        super(props);
        this.onSuccess = this.onSuccess.bind(this);
    }
    
    onSuccess(data){
        
        axios.post('polls', data)
        .then(res => {
            if(res.data.message === 'success'){
                this.props.history.push('/polls/' + res.data.data.id);
            }
        })
        .catch(err => {
            console.log('create fail', err);
        });
        
    }
    
    render() {
        return (
            <Paper>
                <PollForm new success={this.onSuccess} />
            </Paper>
        )
    }   
}

export default PollNew;